import { HeaderMenuItem, HeaderNavigation } from '@carbon/react';
import { useSelector } from "react-redux";
import { selectWrittenNavigationItems } from "../../../features/application/applicationSlice.js";

const NavigationItems = ({ onItemClick, highlightElement }) => {
    const navItems = useSelector(selectWrittenNavigationItems);

    return (
        <HeaderNavigation aria-label="Data Analysis Tool">
            {navItems.map((item) => {
                return item.active ? (
                    <HeaderMenuItem key={item.name} className="pointer"
                        onClick={() => onItemClick(item)}>{highlightElement(item.name)}</HeaderMenuItem>) : ''
            })
            }
        </HeaderNavigation>
    );
};

export default NavigationItems;